<template>
    <awesome-table
        :items="tags"
        :labels="['name']"
        :options="{
            filters: false,
            sort: false,
            addButton: false,
            link: false,
            searchInput: false,
            isCard: false
        }"
        :pagination="pagination"
        @row-click="onRowClick"
        @pagination-change="onPaginationChange"
    />
</template>

<script>
export default {
    props: {
        isLoan: {
            type: Boolean,
            required: false,
            default: false
        },
        shopId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            pagination: {
                currentPage: 1,
                perPage: 10,
                total: 0
            },
            tags: []
        };
    },

    created() {
        this.getTags();
    },

    methods: {
        async getTags() {
            try {
                const functionName = `${
                    this.isLoan ? 'loanS' : 's'
                }hops/getTags`;

                const { rows, count } = await this.$store.dispatch(
                    functionName,
                    {
                        ...this.pagination,
                        id: this.shopId
                    }
                );

                this.tags = rows;
                this.pagination.total = count;
            } catch (error) {
                console.error(error);
            }
        },

        onPaginationChange(pagination) {
            this.pagination = {
                ...pagination
            };

            this.getTags();
        },

        onRowClick({ name }) {
            const filters = {
                'tags.name': { value: name, type: 'substring' }
            };

            this.$router.push({
                path: `/${this.isLoan ? 'loan-' : ''}shops/${this.shopId}/${
                    this.isLoan ? 'loan-' : ''
                }products`,
                query: {
                    filters: JSON.stringify(filters)
                }
            });
        }
    }
};
</script>
